import * as React from "react";

import { Loader } from "@progress/kendo-react-indicators";
import { Button } from "@progress/kendo-react-buttons";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";

import {
    Grid,
    GridColumn,
} from "@progress/kendo-react-grid";

import {
    State,
} from "@progress/kendo-data-query";

import VaccineNew from "./VaccineNew";
import NavigateToLogin from "./NavigateToLogin";

import { useGetVaccinesQuery } from '../store/sunbright-api';
import { useDeleteVaccineMutation } from '../store/sunbright-api';

const initialDataState: State = {
    filter: {
        logic: "and",
        filters: [
        ],
    },
    sort: [{ field: "species", dir: "asc" }],
};

const VaccinesGrid = (props: any) => {

    const ActionCell = (props:any) => {
        const { dataItem } = props;

        return (
            <td className="k-command-cell">
                <Button
                    icon="trash"
                    style={{ background: "center" }}
                    onClick={(e) => deleteClicked(dataItem)}
                >
                </Button>
            </td>
        );
    };

    const { data: vaccines, error: vaccinesError, isLoading: vaccinesLoading } = useGetVaccinesQuery(3);
    const [deleteVaccine, response] = useDeleteVaccineMutation();

    const [gridHeight, setGridHeight] = React.useState<string>("600px");

    React.useEffect(() => {
        window.addEventListener("resize", handleResize);
    }, []);
    React.useEffect(() => {
        setGridHeight((window.innerHeight - 120) + "px");
    }, [vaccines]);

    const handleResize = () => {
        setGridHeight((window.innerHeight - 100) + "px");
    };

    const deleteClicked = (dataItem:any) => {
        setVaccineToDelete(dataItem);
        setConfirmDelete(true);
    };

    const deleteSelectedVaccine = (dataItem: any) => {

        deleteVaccine(dataItem)
            .unwrap()
            .then((payload) => { })
            .catch((error) => {
                console.log(error)
            });

        setConfirmDelete(false);
    };
   
    const [dataState, setDataState] = React.useState<State>(initialDataState);
    const [newVaccine, setNewVaccine] = React.useState<boolean>(false);
    const [confirmDelete, setConfirmDelete] = React.useState<boolean>(false);
    const [vaccineToDelete, setVaccineToDelete] = React.useState<any>();

    return (
        <React.Fragment>
            {(newVaccine) ?
                (<div>
                    <VaccineNew 
                        onReturn={(submitted: boolean) => setNewVaccine(false)}
                    />
                </div>) :
                (<div>
                    <div className="sds-gridHeader">Vaccines</div>
                    {vaccinesError ? (<NavigateToLogin />) : vaccinesLoading ? <Loader size="large" type="converging-spinner" /> : vaccines ? (
                    <div>
                        <div>
                            {(confirmDelete) &&
                                <Dialog title={<div><span className="k-icon k-font-icon k-i-info" style={{ color: "green" }} ></span>&nbsp;Please confirm</div>}
                                    onClose={(e) => setConfirmDelete(false)}>
                                    <p style={{ margin: "25px", textAlign: "center" }}>
                                            Are you sure you want to delete <br />{vaccineToDelete.description} ?
                                    </p>
                                    <DialogActionsBar>
                                        <button
                                                className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                                                onClick={(e) => deleteSelectedVaccine(vaccineToDelete)}
                                       >
                                            Yes
                                        </button>
                                        <button
                                            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                                            onClick={(e) => setConfirmDelete(false)}
                                        >
                                            No
                                        </button>
                                    </DialogActionsBar>
                                </Dialog>
                            }
                        </div>
                       <Button
                            themeColor={"primary"}
                            icon="plus-circle"
                            onClick={() => setNewVaccine(true)}
                            style={{ position: "absolute", top: "46px", right: "64px", width: "128px", zIndex:"99" }}>
                        New Vaccine
                        </Button>
                        <Grid
                            style={{ height: gridHeight }}
                            className="vaccineGrid sds-selectable"
                            data={vaccines}
                            sortable={true}
                            filterable={false}
                            resizable={true}
                            reorderable={true}
                            size={"small"}
                        >
                            <GridColumn field="species" title="Species" filterable={false} filter="text" />
                            <GridColumn field="description" title="Description" filterable={false} filter="text" />
                                <GridColumn cells={{ data: (props) => <ActionCell {...props} /> }} width="100px" />
                            </Grid>
                    </div>
                ) : null}
                </div>)
            }
        </React.Fragment>
    );
}
export default VaccinesGrid;
